import FacilityPage from "@/components/site-settings/FacilityPage";
import { createFileRoute } from "@tanstack/react-router";

export interface FacilitySearchParams {
  nodeId?: string;
  lineId?: string;
}

export const Route = createFileRoute("/_authenticated/site-settings/facility")({
  validateSearch: (search: Record<string, unknown>): FacilitySearchParams => ({
    nodeId: (search.nodeId as string) || undefined,
    lineId: (search.lineId as string) || undefined,
  }),
  component: FacilityPage,
});
